module.exports = __webpack_public_path__ + "static/media/disabledTicketIcon.b3d1d4a5.svg";